module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwAgMAAAAqbBEUAAAACVBMVEUAAABUYnZVYndKB3mtAAAAAnRSTlMAf7YpoZUAAAA8SURBVCjPzcshAQAwDMTAllTES6y0qRw9Mr6wA6n/azEiYl2Oi4jY4wJGROwTESNa1IqIES1qRcSIrt+7Z7ITM+Po0c8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/supplychain/arrow-down-s-fill.png
// module id = GMfY
// module chunks = 44